export const genderEnum = [
  { value: 0 }, //0=男性
  { value: 1 }, //1=女性
  { value: 2 }, //2=不願透露
];
